// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slider-section[data-v-e5099762]{height:auto;height:var(--slider-height,auto);max-height:none;max-height:var(--slider-height,none)}.slider-section[data-v-e5099762],.slider-section__content[data-v-e5099762]{display:flex;flex:1 1 auto;flex-direction:column;min-height:0}.slider-section__content[data-v-e5099762]{height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
